import { Injectable, Inject } from '@angular/core'
import { IUser } from '../models/account/user.model'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router, Route, UrlSerializer } from '@angular/router'
import { UserLogin } from '../models/account/user-login.model';
import { LoginResponse } from '../models/account/login-response.model';
import { LocalStorageService } from './local-storage.service';
import { Const } from './Const';
import { AlertService, MessageSeverity } from './alert.service';
import { Core } from '../shared/core';

import { CommonFactory } from './common-factory.service';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';


@Injectable()
export class AuthService {
  currentUser: IUser;

  constructor(private http: HttpClient, private localStorageService: LocalStorageService, private alertService: AlertService
    , @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private  msalService: MsalService, private msalBroadcastService: MsalBroadcastService
  )
  {
    
  }

  loginUser() {
    return this.msalService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest);
  }

  logOff() {
    if (this.msalService.instance.getActiveAccount() != null) {
      this.getLogOffEndpoint().subscribe();
      this.msalService.logout().subscribe();
      this.alertService.showMessage('Logout', `${this.currentUser.userName} logged out`, MessageSeverity.information);
      this.localStorageService.removeData(Const.CurrentUser);
    }
 }

  getLoginEndpoint<LoginResponse>(userid: string, userName: string, email: string): Observable<LoginResponse> {
    const params = new HttpParams()
      .append('userid', userid)
      .append('username', userName)
      .append('email', email);
    const requestBody = params.toString();

    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };

    return this.http.post<LoginResponse>('/account/login', requestBody, options);
  }

  processLoginResponse(response: LoginResponse, rememberMe?: boolean) {
     this.currentUser = {
         userName: response.userName,
         password: response.password,
         roles: [],
         email: response.email,
         userImage: "/UserImages/" + response.userName + ".png"
     }
    this.localStorageService.saveData(Const.CurrentUser, this.currentUser);
   return this.currentUser;
  }

  private getLogOffEndpoint(){
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };
    return this.http.post('/account/LogOff', null, options);
  }

  isAuthenticated() {
    if (this.msalService.instance.getActiveAccount() != null) {
      this.currentUser = {
        userName: this.msalService.instance.getActiveAccount().username,
        password: "",
        roles: [],
        email: this.msalService.instance.getActiveAccount().username,
        userImage: "/UserImages/" + this.msalService.instance.getActiveAccount().username + ".png"
      }
      return true;
    }
    this.currentUser = {
      userName: "",
      password: "",
      roles: [],
      email: "",
      userImage: ""
    }
    return false;
  }


}

